import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../../../../../../Config';

const BankDealerAdd = ({ show, handleClose, refresh, token, user_id, b64id, branch_id }) => {

    const [disableSubmit, setDisableSubmit] = useState(false);
    const initialValues = {
        entity_name: "",
        set_default: false,
        address: "",
        account_no: "",
        ad_code: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.customer_id = atob(b64id)
                values.general_branch_id = branch_id
                axios.post(`${adminMainUrl}/api/organization/general/branch/custom_detail/bank/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refresh();
                            handleClose();
                            resetForm();
                            setDisableSubmit(false);
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(err => {
                        let msg = "Internal server error!";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.msg) {
                                    msg = err.response.data.msg
                                }
                            }
                        };
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                setDisableSubmit(false);
                toast.error(error.message);
            }
        }
    });


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement='end' name="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Bank Details</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="col-md-12">
                                <label htmlFor="entity_name" className="form-label">Entity Name</label>
                                <input
                                    type='text'
                                    maxLength={50}
                                    className='form-control form-control-sm'
                                    id="entity_name"
                                    name="entity_name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.entity_name}
                                />
                            </div>
                            <div className="col-md-12 d-flex">
                                <label htmlFor="entity_name" className="form-label">Set as Default</label>
                                <input
                                    className='mx-3'
                                    type='checkbox'
                                    id="set_default"
                                    name="set_default"
                                    onChange={(e) => { formik.setFieldValue('set_default', e.target.checked) }}
                                    checked={formik.values.set_default}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="entity_name" className="form-label">Bank/Dlr Name and Address</label>
                                <input
                                    type='text'
                                    maxLength={250}
                                    className='form-control form-control-sm'
                                    id="address"
                                    name="address"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.address}
                                />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="account_no" className="form-label">Account No.</label>
                                <input
                                    type='text'
                                    minLength={8}
                                    maxLength={35}
                                    className='form-control form-control-sm'
                                    id="account_no"
                                    name="account_no"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.account_no}
                                    onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}

                                />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="ad_code" className="form-label">AD Code</label>
                                <input
                                    type='text'
                                    minLength={8}
                                    maxLength={35}
                                    className='form-control form-control-sm'
                                    id="ad_code"
                                    name="ad_code"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.ad_code}
                                    onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}

                                />
                            </div>
                            <div className="col-md-12 text-end mt-2">
                                <button className="btn btn-submit btn-danger">Submit</button>
                            </div>
                        </form>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default BankDealerAdd